import React from "react";

const Chapter1 = () => {
  return (
    <>
      <h2>
        <em>E. coli</em> Storyline
      </h2>
      <img
        style={{ width: "88%", margin: "20px auto" }}
        alt="ecoli banner"
        src="/static/img/storylines/ecoli_banner.png"
      />
      <p>
        Don't know much about <em>E. coli</em>? The storyline is the perfect
        place to start. Learn not only what <em>E. coli</em> are, but
        additionally what can be done to reduce its pollutant load in the South
        Platte River and its tributaries.
      </p>
    </>
  );
};

export default Chapter1;
